import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './NoItem.css';
import bt from '../../../components/commonStyle.css';

// Locale
import messages from '../../../locale/messages';

//Image
import noListImage from '/public/SiteImages/noReservation.svg';
import noTripImage from '/public/SiteImages/noTripImg.svg';


const NoItem = ({ userType, type, isTrip }) => {

  return (
    <div>
      <div className={s.textCenter}>
        <img src={isTrip ? noTripImage : noListImage} />
        <div className={cx(s.noListSubHeading)}>
          {
            userType === 'host' && <div>
              {type == 'current' &&
                <FormattedMessage {...messages.noUpcomingReservation} />

              }
              {type != 'current' &&
                <FormattedMessage {...messages.noPreviousReservation} />
              }
            </div>
          }
          {
            userType === 'guest' && <div>
              {type == 'current' && <span><FormattedMessage {...messages.noUpcomingTrips} /></span>}
              {type != 'current' && <span><FormattedMessage {...messages.noPreviousTrips} /></span>}
            </div>
          }
        </div>
      </div>
    </div>
  );
}

NoItem.propTypes = {
  userType: PropTypes.string.isRequired,
  formatMessage: PropTypes.any,
};

export default withStyles(s, bt)(NoItem);